import { useMemo } from "react";

import type { FilterOption } from "~/shared/section";

import { useScenesByProject } from "./api";

/**
 * Сцены выбранного проекта как опции панели фильтров. Архивные включены
 * намеренно: фильтр обязан находить и то, что уже убрано из активной работы,
 * иначе прошлые генерации становятся недостижимы. Четыре VM списков повторяли
 * эту пару «запрос + маппинг» дословно.
 */
export function useSceneFilterOptions(projectId: string | undefined): FilterOption[] {
    const { data } = useScenesByProject(projectId, { includeArchived: true });
    return useMemo(() => (data?.data ?? []).map((s) => ({ value: s.id, label: s.name })), [data]);
}
